import http from '~/http/services/pos';
import { usePrinter } from '~/App/Layout/providers/PrinterProviderV2';
import message from '~/utils/message';
import i18n from '~/i18n';
import { useCallback } from 'react';
import { PrintResponse } from '~/types/printer';

const API_URL = '/api/v2/cashier-balancings';

export const usePrintReport = () => {
  const { print } = usePrinter();
  const printCashierReport = useCallback(
    async (cashierBalancingId: string) => {
      try {
        await print(({ printMethod, printerId }) => {
          return http.post<PrintResponse>(
            `${API_URL}/${cashierBalancingId}/closings/prints`,
            { printMethod, printerId }
          );
        });
        message.success(i18n.t('message_success_print'));
      } catch (e: any) {
        message.error(e.message);
      }
    },
    [print]
  );

  const printCashierSoldItems = useCallback(
    async (cashierBalancingId: string) => {
      try {
        await print(({ printMethod, printerId }) => {
          return http.post<PrintResponse>(
            `${API_URL}/${cashierBalancingId}/sold-items/prints`,
            { printMethod, printerId }
          );
        });
        message.success(i18n.t('message_success_print'));
      } catch (e: any) {
        message.error(e.message);
      }
    },
    [print]
  );
  return {
    printCashierReport,
    printCashierSoldItems,
  };
};
